// https://github.com/Miragon/camunda-modeler-i18n-plugin/blob/develop/client/bpmnjs-i18n-extension/languages/de/other.js

/**
 * This file contains German translations for other components.
 */
export const base2 = {
    'About example data': 'Über Beispieldaten',
    'Align elements bottom': 'Elemente unten ausrichten',
    'Align elements center': 'Elemente zentrieren',
    'Align elements left': 'Elemente links ausrichten',
    'Align elements middle': 'Elemente mittig ausrichten',
    'Align elements right': 'Elemente rechts ausrichten',
    'Align elements top': 'Elemente oben ausrichten',
    'Allowed answers': 'Erlaubte Antworten',
    Annotation: 'Anmerkung',
    'Append element': 'Element anfügen',
    Applied: 'Angewendet',
    'Assign to process variable': 'Prozessvariable zuweisen',
    Beispielausgabe: 'Beispielausgabe',
    Beispieldaten: 'Beispieldaten',
    'Business Rule Task': 'Geschäftsregel-Aufgabe',
    'Call Activity': 'Aufruf-Aktivität',
    'Cancel Boundary Event': 'Abbruch-Grenzereignis',
    'Cancel Event': 'Abbruchsereignis',
    'Candidate starter groups': 'Gruppen der potenziellen Initiatoren',
    'Case Execution Listener': 'Fallausführungs-Listener',
    'Case Execution Listeners': 'Fallausführungs-Listener',
    'Case Id': 'Fall-ID',
    'Case Name': 'Fallname',
    'Catching Event': 'Eingetretenes Ereignis',
    'Choose element template': 'Elementvorlage auswählen',
    'Clear predefined values.': 'Vordefinierte Werte löschen.',
    'Close minimap': 'Minikarte schließen',
    'Collaboration Process': 'Kollaborationsprozess',
    'Collapsed Pool': 'Zugeklappter Pool',
    'Collapsed Subprocess': 'Zugeklappter Teilprozess',
    Collect: 'Sammeln',
    collectEntries: 'Einträge sammeln',
    'Compensation Boundary Event': 'Kompensations-Grenzereignis',
    'Compensation End Event': 'Kompensations-Endereignis',
    'Compensation Event': 'Kompensationsereignis',
    'Compensation Intermediate Throw Event':
        'Kompensations-Zwischenauslöseereignis',
    'Complex Gateway': 'Komplexes Gateway',
    'Conditional Boundary Event (non-interrupting)':
        'Bedingungsgrenzereignis (nicht unterbrechend)',
    'Conditional Boundary Event': 'Bedingungsgrenzereignis',
    'Conditional Event': 'Bedingungsereignis',
    'Conditional Flow': 'Bedingter Fluss',
    'Conditional Intermediate Catch Event':
        'Bedingtes Zwischeneintretendes Ereignis',
    'Conditional Start Event': 'Bedingtes Startereignis',
    'Connect using Information/Knowledge/Authority Requirement or Association':
        'Mit Informations-/Wissens-/Befugnisanforderung oder Assoziation verbinden',
    'Copy Input Column': 'Eingabespalte kopieren',
    'Copy Output Column': 'Ausgabespalte kopieren',
    'Copy Rule': 'Regel kopieren',
    'Create Decision': 'Entscheidung erzeugen',
    'Create element': 'Element erstellen',
    'Create Input Data': 'Eingabedaten erzeugen',
    'Create Knowledge Model': 'Wissensmodell erzeugen',
    'Create Knowledge Source': 'Wissensquelle erzeugen',
    'Custom properties': 'Benutzerdefinierte Eigenschaften',
    'Customer Status': 'Kundenstatus',
    'Cut Input Column': 'Eingabespalte ausschneiden',
    'Cut Output Column': 'Ausgabespalte ausschneiden',
    'Cut Rule': 'Regel ausschneiden',
    'Data Object': 'Datenobjekt',
    'Data Type': 'Datentyp',
    'Data-based Exclusive Gateway': 'Datenbasiertes exklusives Gateway (XOR)',
    'Decision name: ': 'Entscheidungsname: ',
    'Decision table': 'Entscheidungstabelle',
    'Decision Table': 'Entscheidungstabelle',
    'Default Flow': 'Standardablauf',
    'Definition Id': 'Definitions-ID',
    'Definition name is used': 'Definitionsname wird verwendet',
    'Definition Name': 'Definitionsname',
    Definition: 'Definition',
    Deprecated: 'Veraltet',
    Description: 'Beschreibung',
    'Edit String': 'Zeichenkette bearbeiten',
    'Empty pool/participant (removes content)':
        'Leerer Pool/Teilnehmer (Inhalt wird entfernt)',
    'Empty pool/participant': 'Leerer Pool/Teilnehmer (Inhalt wird entfernt)',
    Empty: 'Leer',
    'End Event': 'Endereignis',
    'Ereignis-Teilprozess': 'Ereignisuntergeordneter Prozess',
    'Error Boundary Event': 'Fehler-Grenzereignis',
    'Error End Event': 'Fehler-Endereignis',
    'Error Event': 'Fehlerereignis',
    'Escalation Boundary Event (non-interrupting)':
        'Eskalations-Grenzereignis (nicht unterbrechend)',
    'Escalation Boundary Event': 'Eskalations-Grenzereignis',
    'Escalation End Event': 'Eskalations-Endereignis',
    'Escalation Intermediate Throw Event':
        'Eskalations-Zwischenauslöseereignis',
    'Event is ignored due to entry criteria':
        'Ereignis wird aufgrund von Eintrittsregeln ignoriert',
    'Event-based Exclusive Gateway':
        'Ereignisbasiertes exklusives Gateway (XOR)',
    Event: 'Ereignis',
    'Example Data documentation': 'Beispieldaten-Dokumentation',
    'Example data must be a JSON object literal.':
        'Beispieldaten müssen ein JSON-Objektliteral sein.',
    'Exception Flow': 'Ausnahmefluss',
    Exception: 'Ausnahme',
    'Exklusives Gateway': 'Datenbasiertes exklusives Gateway (XOR)',
    'Expand (not reversible)': 'Aufklappen (nicht umkehrbar)',
    'Expanded Pool': 'Aufgeklappter Pool',
    'Expanded Subprocess': 'Aufgeklappter Teilprozess',
    FEEL: 'FEEL',
    First: 'Erste',
    'flow elements must be children of pools/participants':
        'Flow-Elemente müssen innerhalb von Pools/Teilnehmern platziert werden',
    Foo: 'Foo',
    Gateway: 'Gateway',
    Groovy: 'Groovy',
    ID: 'ID',
    'If Part Condition': 'Wenn-Teil-Bedingung',
    'Inclusive Gateway': 'Inklusives Gateway (OR)',
    'Input Expression': 'Eingabeausdruck',
    'Input Label': 'Eingabebezeichnung',
    'Input Type': 'Eingabetyp',
    'Input Values': 'Eingabewerte',
    'Input Variable': 'Eingabevariable',
    'Intermediate Throw Event': 'Ausgelöstes Zwischenereignis',
    'Item Control': 'Elementsteuerung',
    Java: 'Java',
    JavaScript: 'JavaScript',
    JRuby: 'JRuby',
    JUEL: 'JUEL',
    Key: 'Schlüssel',
    'Learn more': 'Erfahren Sie mehr',
    'Link Intermediate Catch Event':
        'Verknüpftes Zwischenereignis (Empfangend)',
    'Link Intermediate Throw Event': 'Verknüpftes Zwischenereignis (Sendend)',
    'Listener is notified for all kinds of events':
        'Ereignis wird für alle Arten von Ereignissen benachrichtigt',
    Listener: 'Ereignis',
    'Literal Expression': 'Literaler Ausdruck',
    'Local variable assignment': 'Lokale Variablenzuweisung',
    'Manual Task': 'Manuelle Aufgabe',
    'Message Boundary Event (non-interrupting)':
        'Nachrichtengrenzereignis (nicht unterbrechend)',
    'Message Boundary Event': 'Nachrichtengrenzereignis',
    'Message End Event': 'Nachrichtenendereignis',
    'Message Intermediate Catch Event': 'Nachrichten-Zwischenfangerereignis',
    'Message Intermediate Throw Event': 'Nachrichten-Zwischenwurfereignis',
    'Message Start Event': 'Nachrichtenstartereignis',
    'must not be empty.': 'darf nicht leer sein.',
    'Must not be empty.': 'Darf nicht leer sein.',
    'Must provide a standard event': 'Muss ein Standardereignis bereitstellen',
    'Not found': 'Nicht gefunden',
    'Open minimap': 'Minikarte öffnen',
    'Output Expression': 'Ausgangsausdruck',
    'Output Label': 'Ausgabebezeichnung',
    'Output Name': 'Ausgabename',
    'Output order': 'Ausgabereihenfolge',
    'Output Type': 'Ausgabetyp',
    'Output Values': 'Ausgabewerte',
    Output: 'Ausgang',
    'Parallel Gateway': 'Paralleles Gateway (AND)',
    'Paste Input Column Left': 'Eingabespalte links einfügen',
    'Paste Input Column Right': 'Eingabespalte rechts einfügen',
    'Paste Output Column Left': 'Ausgabespalte links einfügen',
    'Paste Output Column Right': 'Ausgabespalte rechts einfügen',
    'Paste Rule Above': 'Regel oberhalb einfügen',
    'Paste Rule Below': 'Regel unterhalb einfügen',
    PMML: 'PMML',
    'Predefined Values': 'Vordefinierte Werte',
    Priority: 'Priorität',
    'Process variable assignment': 'Prozessvariablenzuweisung',
    'Process variable name must not be empty.':
        'Der Name der Prozessvariable darf nicht leer sein.',
    'Process variable name must not contain spaces.':
        'Der Name der Prozessvariable darf keine Leerzeichen enthalten.',
    Python: 'Python',
    Question: 'Frage',
    'receive messages.': 'Nachrichten empfangen.',
    'Receive Task': 'Empfangsaufgabe',
    Reference: 'Referenz',
    'Remove Cell Description': 'Zellenbeschreibung entfernen',
    'Remove Input Column': 'Eingabespalte entfernen',
    'Remove Output Column': 'Ausgabespalte entfernen',
    'Remove Rule': 'Regel entfernen',
    Remove: 'Entfernen',
    'Repeat On Standard Event': 'Wiederholen bei Standardereignis',
    'Repetition Rule': 'Wiederholungsregel',
    'Required Rule': 'Erforderliche Regel',
    resultList: 'Ergebnisliste',
    'Rule is overwritten by item control':
        'Regel wird durch Elementsteuerung überschrieben',
    'Rule order': 'Regelreihenfolge',
    Rule: 'Regel',
    Rules: 'Regeln',
    'Scientific notation is disallowed in FEEL.':
        'Wissenschaftliche Notation ist in FEEL nicht erlaubt.',
    'Script Task': 'Skriptaufgabe',
    'Search in diagram': 'Im Diagramm suchen',
    Select: 'Auswählen',
    'Send Task': 'Sendeaufgabe',
    'Service Task': 'Serviceaufgabe',
    'Set Value': 'Wert setzen',
    'Show Standard Event': 'Standardereignis anzeigen',
    'Signal Boundary Event (non-interrupting)':
        'Signalgrenzereignis (nicht unterbrechend)',
    'Signal Boundary Event': 'Signalgrenzereignis',
    'Signal End Event': 'Signalendereignis',
    'Signal Intermediate Catch Event': 'Signalzwischenereignis (Empfangend)',
    'Signal Intermediate Throw Event': 'Signalzwischenereignis (Sendend)',
    'Signal Start Event': 'Signalstartereignis',
    singleEntry: 'Einzeleintrag',
    singleResult: 'Einzelergebnis',
    'Standard Event': 'Standardereignis',
    'Start Event': 'Startereignis',
    'Strings must be in double quotes.':
        'Zeichenketten müssen in doppelten Anführungszeichen stehen.',
    'Sub Process (collapsed)': 'Zugeklappter Teilprozess',
    'Sub Process (expanded)': 'Aufgeklappter Teilprozess',
    'Sub Process': 'Teilprozess',
    'Task Listeners': 'Aufgaben-Ereignisse',
    Task: 'Aufgabe',
    Template: 'Vorlage',
    Templates: 'Vorlagen',
    'Terminate End Event': 'Beendendes Endereignis',
    'The follow up date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)':
        'Das Folgetermin als EL-Ausdruck (z.B. ${someDate}) oder als ISO-Datum (z.B. 2015-06-26T09:54:00)',
    'The template applied was not found. Therefore, its properties cannot be shown. Unlink to access the data.':
        'Die angewendete Vorlage wurde nicht gefunden. Daher können ihre Eigenschaften nicht angezeigt werden. Verknüpfung aufheben, um auf die Daten zuzugreifen.',
    'This maps to the decision definition key.':
        'Dies wird dem Entscheidungsdefinitionsschlüssel zugeordnet.',
    'This maps to the process definition key.':
        'Dies wird dem Prozessdefinitionsschlüssel zugeordnet.',
    'This maps to the task definition key.':
        'Dies wird dem Aufgabendefinitionsschlüssel zugeordnet.',
    'This template is deprecated.': 'Diese Vorlage ist veraltet.',
    'Timer Boundary Event (non-interrupting)':
        'Zeitgrenzereignis (nicht unterbrechend)',
    'Timer Boundary Event': 'Zeitgrenzereignis',
    'Timer Intermediate Catch Event': 'Zeitgesteuertes Zwischenereignis',
    'Timer Start Event': 'Zeitgesteuertes Startereignis',
    Transaction: 'Transaktion',
    Transition: 'Transition',
    Unique: 'Eindeutig',
    Unlink: 'Verknüpfung aufheben',
    'Update available': 'Update verfügbar',
    Update: 'Aktualisieren',
    'User Task': 'Benutzer-Aufgabe',
    'Variable Listener': 'Variablen-Ereignis',
    'Variable Listeners': 'Variablen-Ereignisse',
} as const;
